import Axios from '../../library/Axios'

export const CampaignViewAction = (id: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'CAMPAIGN_VIEW_REQUEST' })

        const { data } = await new Axios().get(`/get/project/${id}`)

        dispatch({ type: 'CAMPAIGN_VIEW_SUCCESS', payload: data })
    } catch (error) {
        // console.log(error)
    }
}

export const CampaignTreeDocAction = (id: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'CAMPAIGN_TREE_DOCS_REQUEST' })

        const { data } = await new Axios().get(`/get/project/${id}/tree/docs`)

        dispatch({ type: 'CAMPAIGN_TREE_DOCS_SUCCESS', payload: data })
    } catch (error) {
    }
}

export const CampaignDownloadDocumentAction = (donation_id: number, seedling_id: string, saplings: string, project_id: number, template_id: number, donator: string, memorial: string, gift_name: string, gift_mobile: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'CAMPAIGN_DOWNLOAD_DOCUMENT_REQUEST' })

        const { data } = await new Axios().post(`/post/download/document/tree`, {
            donation_id: donation_id,
            seedling_id: seedling_id,
            saplings: saplings,
            project_id: project_id,
            template_id: template_id,
            donator: donator,
            memorial: memorial,
            gift_name: gift_name,
            gift_mobile: gift_mobile,
        })

        dispatch({ type: 'CAMPAIGN_DOWNLOAD_DOCUMENT_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'CAMPAIGN_DOWNLOAD_DOCUMENT_ERROR' })
    } finally {
        dispatch({ type: 'CAMPAIGN_DOWNLOAD_DOCUMENT_RESET' })
    }
}

export const CampaignDownloadDocumentOldAction = (tree_doc_id: number, template_id: number, donator: string, memorial: string, gift_name: string, gift_mobile: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'CAMPAIGN_DOWNLOAD_DOCUMENT_OLD_REQUEST' })

        const { data } = await new Axios().post(`/post/download/document/tree/old`, {
            tree_doc_id: tree_doc_id,
            template_id: template_id,
            donator: donator,
            memorial: memorial,
            gift_name: gift_name,
            gift_mobile: gift_mobile,
        });

        dispatch({ type: 'CAMPAIGN_DOWNLOAD_DOCUMENT_OLD_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'CAMPAIGN_DOWNLOAD_DOCUMENT_OLD_ERROR' })
    } finally {
        dispatch({ type: 'CAMPAIGN_DOWNLOAD_DOCUMENT_OLD_RESET' })
    }
}

export const CampaignDeleteTreeDocsAction = (project_id: number, doc_id: number = 0) => async (dispatch: any) => {
    try {
        dispatch({ type: 'CAMPAIGN_DELETE_TREE_DOCUMENT_REQUEST' })

        const { data } = await new Axios().post(`/post/docs/tree/delete`, {
            project_id: project_id,
            doc_id: doc_id
        });

        dispatch({ type: 'CAMPAIGN_DELETE_TREE_DOCUMENT_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'CAMPAIGN_DELETE_TREE_DOCUMENT_ERROR' })
    } finally {
        dispatch({ type: 'CAMPAIGN_DELETE_TREE_DOCUMENT_RESET' })
    }
}

export const CampaignCommentsAction = (id: string, page: number = 0) => async (dispatch: any) => {
    try {
        dispatch({ type: 'CAMPAIGN_COMMENTS_REQUEST' })

        const { data } = await new Axios().get(`/get/project/${id}/comments/${page}`)

        dispatch({ type: 'CAMPAIGN_COMMENTS_SUCCESS', payload: data })
    } catch (error) {
        // console.log(error)
    }
}

export const CampaignDonationsAction = (id: string, page: number = 0) => async (dispatch: any) => {
    try {
        dispatch({ type: 'CAMPAIGN_DONATIONS_REQUEST' })

        const { data } = await new Axios().get(`/get/project/${id}/donations/${page}`)

        dispatch({ type: 'CAMPAIGN_DONATIONS_SUCCESS', payload: data })
    } catch (error) {
        // console.log(error)
    }
}

export const CampaignDonateAction = (id: any) => async (dispatch: any) => {
    try {
        dispatch({ type: 'CAMPAIGN_DONATE_SUCCESS_REQUEST' })

        const { data } = await new Axios().get(`/get/donation/${id}`)

        dispatch({ type: 'CAMPAIGN_DONATE_SUCCESS_SUCCESS', payload: data })
    } catch (error) {
        // console.log(error)
    }
}

export const DonationDoGetAction = (campaign_id: any) => async (dispatch: any) => {
    try {
        dispatch({ type: 'DONATION_DO_GET_REQUEST' })

        const { data } = await new Axios().get(`/get/project/${campaign_id}/donation_do`)

        dispatch({ type: 'DONATION_DO_GET_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'DONATION_DO_GET_ERROR' })
    }
}